import { Segment } from "@ts/types/segment.type"
import {
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableRow,
} from "@components/dataDisplay/table/Table"

const IndexTable = ({ segment }: { segment: Segment }) => {
  return (
    <Table style={{ marginBottom: 10 }}>
      <TableHeader>
        <TableRow>
          <TableHeaderCell>Basiswert</TableHeaderCell>
          <TableHeaderCell align="right">Last</TableHeaderCell>
          <TableHeaderCell align="right">Change</TableHeaderCell>
          <TableHeaderCell align="right">%</TableHeaderCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        <TableRow>
          <TableCell>{segment.name}</TableCell>
          <TableCell align="right">{segment.titleInstrument.mid}</TableCell>
          <TableCell
            align="right"
            numberType={`${segment.titleInstrument.change.startsWith("-") ? "negative" : "positive"}`}
          >
            {segment.titleInstrument.change}
          </TableCell>
          <TableCell
            align="right"
            numberType={`${segment.titleInstrument.changePercent.startsWith("-") ? "negative" : "positive"}`}
          >
            {segment.titleInstrument.changePercent}%
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default IndexTable
